import {addSubmitLoader, inputHasError, validateDisabledButton, validateEmail} from "./validation";
// import {getCreatedHiddenInput} from "./paymentSubmitCommon";


export function contactFormLogic()  {
  // if (!window.location.href.includes("descriptor") && !window.location.href.includes("contact")) {
  //   return;
  // }
  let alreadySubmitted;
  const form = document.querySelector('[name="contact-us"]');
  if (!form) {
    return;
  }
  const emailInput = form.querySelector("#email") || form.querySelector("#contact_us_email");
  const firstNameInput = form.querySelector("#firstName") || form.querySelector("#contact_us_firstName");
  const messageInput = form.querySelector("#message") || form.querySelector("#contact_us_message");
  const formSubmit = form.querySelector("#contact_us_send");
  if (!emailInput || !formSubmit) {
    return
  }
  const inputsToCheck = [emailInput, firstNameInput, messageInput];
  // console.log("formSubmit", formSubmit);
  // console.log("form", form);

  const onBlurInput = (event) => {
    const hasError = inputHasError(event.target);
    hasError
      ? event.target.classList.add("ui-input--error")
      : event.target.classList.remove("ui-input--error");
    event.target.classList.remove("ui-input--focused");
    validateDisabledButton(formSubmit, inputsToCheck);
  }

  const onInputFocus = (event) => {
    if (!event.target.classList.contains("ui-input--touched")) {
      event.target.classList.add("ui-input--touched")
    }
    if (!event.target.classList.contains("ui-input--focused")) {
      event.target.classList.add("ui-input--focused")
    }
  }

  const onInputChange = () => {
    const shouldCheckSubmit = inputsToCheck.every((input) => input.value);
    if (shouldCheckSubmit) {
      validateDisabledButton(formSubmit, inputsToCheck);
    }
  }
  const onFormSubmit = async (event) => {
    inputsToCheck.forEach(input => {
      if (!input) {
        return
      }
      onBlurInput({target: input})
    });
    const buttonDisabled = validateDisabledButton(formSubmit, inputsToCheck);
    if (buttonDisabled || alreadySubmitted) {
      formSubmit.disabled = true;
      event.preventDefault();
      return false
    }

    const token = window.hcaptcha.getResponse(window.__hcaptchaWidgetId);
    if (!token) {
      return;
    }

    alreadySubmitted = true;
    formSubmit.disabled = true;
    addSubmitLoader(formSubmit);

    const lastNameInput =
      form.querySelector("#lastName") ||
      form.querySelector("#contact_us_lastName");

    const phoneInput =
      form.querySelector("#phone") ||
      form.querySelector("#contact_us_phone");

    const payload = {
      customerEmail: emailInput && emailInput.value ? emailInput.value : "",
      firstName: firstNameInput && firstNameInput.value ? firstNameInput.value : "",
      lastName: lastNameInput && lastNameInput.value ? lastNameInput.value : "",
      phone: phoneInput && phoneInput.value ? phoneInput.value : "",
      message: messageInput && messageInput.value ? messageInput.value : "",
      hCaptchaResponse: token
    };

    const resetState = () => {
      alreadySubmitted = false;
      formSubmit.disabled = false;

      if (window.hcaptcha && typeof window.__hcaptchaWidgetId !== "undefined") {
        window.hcaptcha.reset(window.__hcaptchaWidgetId);
      }
    };

    try {
      const resp = await fetch("/pgh/public_api/member/contact-us", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!resp.ok) {
        resetState();
        return;
      }

      resetState();
    } catch (e) {
      resetState();
    }
  }

  const validateEmailInput = (value = emailInput.value) => {
    if (validateEmail(value)) {
      formSubmit.classList.remove("ui-button--disabled");
      emailInput.classList.remove("ui-input--error");
      return true
    } else {
      formSubmit.classList.add("ui-button--disabled");
      emailInput.classList.add("ui-input--error");
      return false
    }
  }
  ["input", "change"].every(property => {
    emailInput.addEventListener(property, (event) => {
      if (emailInput.classList.contains("ui-input--error")) {
        validateEmailInput(event.target.value)
      }
    });
  })
  inputsToCheck.forEach(inputElement => {
    if (inputElement) {
      inputElement.addEventListener("blur", onBlurInput);
      inputElement.addEventListener("focus", onInputFocus);
      inputElement.addEventListener("input", onInputChange);
    }
  });
  emailInput.addEventListener("blur", () => {
    validateEmailInput();
  });

  formSubmit.addEventListener("click", onFormSubmit);

  validateDisabledButton(formSubmit, inputsToCheck);
}
